import { useMemo } from 'react';
import { Menu, MenuCartItem } from '../models/menu.types';
import { Cart } from '../models/cart.types';

// combine attributes from menu items and cart items
export function useMenuWithCartItems(menu?: Menu, cart?: Cart): MenuCartItem[] {
  return useMemo(() => {
    if (!cart?.cartItems || !menu?.menuItems) return [];

    return menu.menuItems.map((menuItem) => ({
      ...menuItem,
      quantity: cart.cartItems.find((cartItem) => cartItem.skuId === menuItem.skuId)?.quantity ?? 0,
    }));
  }, [cart, menu]);
}
